import { v2, baseUri } from '@/lib/config'	
import { months } from 'moment';

export const apiV2 = {
  devices: `${v2}/devices/`,
  activeDevices: `${v2}/devices/watched-not-watched/`,
  deviceFilters: `${v2}/devices/filter/`,
  devicesFilters: `${v2}/devices/filter/category/`,
  deviceSetReportStatus: `${v2}/devices/set-report-pulse/`,
  deviceDetail: args => `${v2}/device/${args}/`,
  deviceDetailImages: args => `${v2}/device/${args}/images/`,
  deviceImage: args => `${v2}/device/admin/${args}/images/new/`,
  deviceImageDelete: args => `${v2}/device/admin/${args}/images/delete/`,
  deviceCreate: `${v2}/device/admin/new/`,
  deviceUpdate: args => `${v2}/device/admin/${args}/`,
  deviceAdminDetail: args => `${v2}/device/admin/${args}/`,
  locationsNameList: `${v2}/locations/list/`,
  userProfile: `${v2}/user/profile/`,
  changeEmail: `${v2}/user/change-email/`,
  changePassword: `${v2}/user/change-password/`,
  signin: `${v2}/sign_in/`,
  signout: `${v2}/sign_out/`,
  signup: `${v2}/sign_up/`,
  signupWithGeneratedPassword: `${v2}/sign_up_with_generated_password/`,
  forgot: `${v2}/user/reset-password/`,
  authCheck: `${v2}/auth_check/`,
  resendEmail: `${v2}/resend-email-verification/`,
  setNewPassword: `${v2}/user/set_new_password/`,
  payoutPreferences: `${v2}/user/bank-account/`,
  emailTokenValidation: `${v2}/token_validate/`,
  saved: `${v2}/saved/`,
  savedDetail: args => `${v2}/saved/${args}/`,
  savedDuplicate: args => `${v2}/saved/${args}/duplicate/`,
  savedCopy: `${v2}/saved/copy-items/`,
  contents: `${v2}/content/`,
  newContent: `${v2}/content/new/`,
  deleteContent: `${v2}/content/delete/`,
  profileMe: `${v2}/user/me/`,
  campaignNew: `${v2}/campaign/new/`,
  campaignAddBulkListing: args => `${v2}/campaign/${args}/devices/add/bulk/`,
  campaignAddListing: args => `${v2}/campaign/${args}/device/add/`,
  campaignRemoveListing: args => `${v2}/campaign/${args}/device/remove/`,
  draftCampaigns: `${v2}/campaign/draft/`,
  duplicateCampaign: args => `${v2}/campaign/${args}/duplicate/`,
  deleteCampaign: args => `${v2}/campaign/${args}/delete/`,
  addMoreCampaign: args => `${v2}/campaign/${args}/unselected_devices/`,
  search: `${v2}/search/devices/`,
  CollectionAddListing: args => `${v2}/collection/${args}/device/add/`,
  addMoreCollection: args => `${v2}/collection/${args}/device/unselected/`,
  collectionList: `${v2}/collection/`,
  collection: `${v2}/collection/`,
  collectionOrder: `${v2}/collection/ordering/`,
  collectionCategory: args => `${v2}/collection/page/${args}/`,
  collectionMenu: `${v2}/collection/for-menu/`,
  collectionDetail: args => `${v2}/collection/${args}/`,
  collectionDetailPublic: args => `${v2}/collection/${args}/public/`,
  collectionDuplicate: args => `${v2}/collection/${args}/duplicate/`,
  collectionSelectedDevice: args => `${v2}/collection/${args}/device/selected/`,
  collectionUnelectedDevice: args => `${v2}/collection/${args}/device/unselected/`,
  collectionRemoveDevice: args => `${v2}/collection/${args}/device/remove/`,
  collectionAddDevice: args => `${v2}/collection/${args}/device/add/`,
  collectionAddBulkDevice: args => `${v2}/collection/${args}/device/add/bulk/`,
  collectionImage: `${v2}/collection/image/`,
  newCollectionImage: `${v2}/collection/image/`,
  collectionQuickFilter: `${v2}/collection/group/for-filter/`,
  collectionGroupList: `${v2}/collection/group/`,
  collectionGroupCreate: `${v2}/collection/group/`,
  collectionGroupListOrder: `${v2}/collection/group/for-order/`,
  collectionGroupOrder: `${v2}/collection/group/ordering/`,
  collectionGroupVisiblity: args => `${v2}/collection/group/${args}/`,
  collectionInGroup: args => `${v2}/collection/group/${args}/list/`,
  collectionGroupRemovePage: args => `${v2}/collection/group/${args}/remove-page/`,
  collectionGroupDetail: args => `${v2}/collection/group/${args}/`,
  collectionGroupUnselected: args => `${v2}/collection/group/${args}/unselected-collection/`,
  collectionGroupSelected: args => `${v2}/collection/group/${args}/selected-collection/`,
  collectionGroupAddCollection: args => `${v2}/collection/group/${args}/add-collection/`,
  collectionGroupDuplicate: args => `${v2}/collection/group/${args}/duplicate/`,
  collectionGroupAddToPage: args => `${v2}/collection/page/${args}/add-group/`,
  collectionRemoveFromGroup: args => `${v2}/collection/${args}/remove-group/`,
  collectionAdvertiserList: args => `${v2}/collection/list/?page=${args}`,
  dashboardHostListings: `dashboard/${v2}/host/listings/`,
  dashboardHostDetail: args => `dashboard/${v2}/host/listings/${args}/detail`,
  groupListMenu: `${v2}/collection/group/for-menu/`,
  pageList: `${v2}/collection/page/`,
  transactionHistory: `${v2}/payment/order/`,
  orderCreate: `${v2}/payment/order/new/`,
  orderSend: `${v2}/payment/order/send/`,
  orderDetail: args => `${v2}/payment/order/${args}/`,
  orderDuplicate: args => `${v2}/payment/order/${args}/duplicate/`,
  midtransToken: args => `${v2}/payment/token/${args}/`,
  invoiceDetail: args => `${v2}/payment/invoice/${args}/`,
  receiptDetail: args => `${v2}/payment/receipt/${args}/`,
  invoicOrderDetail: args => `${v2}/payment/invoice/${args}/summary/`,
  fixOrder: args => `${v2}/payment/order/${args}/duplicate/campaign/`,
  lastPulses: `pulse/${v2}/device/last_pulses/`,
  dashboardHostRevenues: `/dashboard/${v2}/host/revenues/`,
  balanceHistory: `${v2}/balance/my_transactions/`,
  finalBalance: `${v2}/balance/final_balance/`,
  typeBalance: `${v2}/balance/transaction_type/`,
  revenueReport: (month, year) => `${baseUri}${v2}/report/device_revenue/?month=${month}&year=${year}`,
  dashboardHostSchedules: `dashboard/${v2}/host/schedules/`,
  dashboardHostSchedulesDelete: `dashboard/${v2}/host/schedules/delete/`,
  invoiceDetailAnon: args => `${v2}/payment/invoice/link/${args}/`,
  dashboardHostDevices: `dashboard/${v2}/host/devices/`,
  dashboardHostCities: `dashboard/${v2}/host/cities/`,
  dashboardHostSchedulesPlaying: args => `dashboard/${v2}/host/schedules/playing/${args}/`,
  dashboardHostSchedulesPosition: `dashboard/${v2}/host/schedules/position/`,
  dashboardHostSchedulesCreate: `dashboard/${v2}/host/schedules/create/`,
  contactUs: `${v2}/contact_us/new/`,
  hostCampaigns: `dashboard/${v2}/host/campaigns/`,
  hostCampaignsDetail: args => `dashboard/${v2}/host/campaigns/${args}/`,
  hostCampaignsDetailDevice: args => `dashboard/${v2}/host/campaigns/${args}/devices/`,
  hostCampaignsDetailContent: args => `dashboard/${v2}/host/campaigns/${args}/contents/`,
  myCampaigns: `${v2}/campaign/my_campaigns/`,
  campaignDetail: args => `${v2}/campaign/${args}/detail/`,
  pertaminaList: `${v2}/pertamina/`,
  pertaminaDetail: args => `${v2}/pertamina/${args}/`,
  pertaminaLocations: `${v2}/pertamina/locations/`,
  pertaminaDates: `${v2}/pertamina/dates/`,
  pertaminaReport: (id, start, end) => `${baseUri}${v2}/report/pertamina/?id=${id}&start=${start}&end=${end}`,
  searchHistory: `${v2}/search/history/`,
  FinalTransactions: (end) => `${baseUri}${v2}/balance/final_transactions/?end=${end}`,
  AllTransactions: (start, end) => `${baseUri}${v2}/balance/all_transactions/?start=${start}&end=${end}`,
  hijack: `${v2}/tools/hijack/email/`,
  releaseHijack: `${v2}/tools/hijack/release/`,
  closeHijack: `${v2}/tools/hijack/close/`,
  adminVoucher: `${v2}/promo/voucher/`,
  adminVoucherDetail: args => `${v2}/promo/voucher/${args}/`,
  adminVoucherHistory: `${v2}/promo/history/`,
  adWord: `${v2}/digital/google_ad/`,
  sosialMedia: `${v2}/digital/social_media/`,
  socialMediaImage: args => `${v2}/digital/social_media/${args}/`,
  creativeImage: `${v2}/digital/creative_image/`,
  smsBlast: `${v2}/digital/sms_blast/`,
  smsBlastFile: args => `${v2}/digital/sms_blast/${args}/`,
  smsTarget: `${v2}/digital/sms_target/`,
  smsPackage: `${v2}/digital/sms_package/`,
  checkVoucher: `${v2}/promo/voucher/check/`,
  userReport: (start, end) => `${baseUri}${v2}/report/new-users/download-all/?start=${start}&end=${end}`,
  userWithNoCampaignReport: `${baseUri}${v2}/report/users/download-users-with-no-campaign-report/`,
  digitalCampaign: `${v2}/digital/campaigns/`,
  zeroPayment: args => `${v2}/payment/payment_zero_discount/${args}/`,
  campaignsReport: `${baseUri}${v2}/campaign/download/all/`,
  userWithOneCampaignOnlyReport: `${baseUri}${v2}/campaign/download/one_approve_only/`,
  measurementcampaignReport: `${v2}/measurement/campaign/`,
  measurementcampaignReportNoPage: `${v2}/measurement/campaign-no-page/`,
  measurementgetCampaignName: `${v2}/measurement/campaign-no-page-report/`,
  measurementgetCampaignNameNoReport: `${v2}/measurement/campaign-no-page-no-report/`,
  measurementcampaignReportAdd: `${v2}/measurement/detail/add/`,
  measurementGetAgeType: `${v2}/measurement/listing/add/get-age/`,
  measurementGetMobileType: `${v2}/measurement/listing/add/get-mobile/`,
  measurementcampaignReportListing: args => `${v2}/measurement/listing/${args}/`,
  measurementGetInterest: args => `${v2}/measurement/listing/add/get-interest/${args}/`,
  measurementGetListing: args => `${v2}/measurement/listing/add/get-listing/${args}/`,
  measurementGetDevices: args => `${v2}/measurement/listing/add/get-device/${args}/`,
  measurementGetLocations: args => `${v2}/campaign/${args}/locations/`,
  measurementGetPeriod: args => `${v2}/measurement/listing/add/get-period/${args}/`,
  measurementcampaignReportDetailEdit: args => `${v2}/measurement/listing/detail/${args}/`,
  measurementcampaignReportDetailEditPost: `${v2}/measurement/detail/edit/`,
  measurementcampaignReportDetail: args => `${v2}/measurement/campaign/${args}/`,
  measurementcampaignChart: args => `${v2}/measurement/campaign/chart/${args}`,
  measurementGetDate: args => `${v2}/measurement/listing/${args}/inputted-date`,
  measurementCreateCampaignReport: `${v2}/measurement/campaign/report/`,
  measurementGetCampaignReport: args => `${v2}/measurement/campaign/report/${args}/`,
  measurementImpact: args => `${v2}/measurement/campaign/report/impact/${args}/`,
  measurementDownloadImpact: args => `${v2}/measurement/campaign/report/impact/download/${args}/`,
  firstCampaign: `${baseUri}${v2}/campaign/download/first_campaign/`,
  campaignOverview: args => `${v2}/campaign/${args}/overview/`,
  campaignContents: args => `${v2}/campaign/${args}/contents/`,
  realPrice: args => `${baseUri}${args}/real_price/`,
  locationList: `${v2}/locations/admin/`,
  locationAdminDuplicate: `${v2}/locations/admin/duplicate/`,
  locationAdminNew: `${v2}/locations/admin/new/`,
  locationAdminEdit: args => `${v2}/locations/admin/${args}/`,
  locationBrands: `${v2}/locations/admin/brands/`,
  locationAirportTerminal: `${v2}/locations/admin/airport-terminal/`,
  locationOwnership: `${v2}/locations/admin/ownership/`,
  locationProfile: `${v2}/locations/admin/profile/`,
  sharing: `${v2}/sharing/`,
  users: `${v2}/sharing/users/`,
  sharingRevenue: args => `${v2}/sharing/${args}/revenue/`,
  sharingDiscount: args => `${v2}/sharing/${args}/discount/`,
  sharingCost: args => `${v2}/sharing/${args}/cost/`,
  sharingCostDetail: args => `${v2}/sharing/${args[0]}/cost/${args[1]}/`,
  sharingCostAdd: `${v2}/sharing/add_cost/`,
  deviceListing: `${v2}/devices/admin/`,
  duplicateDevicesList: `${v2}/device/admin/duplicate/`,
  editDevice: args => `${v2}/device/admin/${args}/`,
  bus: args => `bus/route/${args}/category`,
  bussearch: `bus/route`,
  buscampaign: args => `bus/campaign/${args}`,
  buscampaigncreate: `bus/campaign`,
  buscampaigndelete: args => `bus/campaign/${args}/delete`,
  busdraft: `bus/draft`,
  buscampaignedit: args => `bus/campaign/${args}/edit`,
  generic: `inventory/GenericInventories/`,
  getPulseTask: `/pulse/${v2}/task/`,
  updatePulseTask: `/pulse/${v2}/task/update/`,
  getTeamOps: `${v2}/operation/assignee/`,
  assignTask: `pulse/${v2}/task/assign/`,
  locationTask: `pulse/${v2}/task/locations/`,
  createMessage : `push/message/create/`,
  getPortTunnel : `${v2}/remote/connection/open/`,
  remoteDeviceList : `${v2}/remote/devices/`,
  devicesPlayback: `report/${v2}/devices/performance/`,
  playbackReport: id => `${v2}/report/${id}/performance/`,
  listCampaign: `${v2}/campaigns/`,
  tvControl: `${v2}/tv/tvcontrol/message/`,
  inventoryGeneric: `inventory/GenericInventories/`,
  inventoryBrands: `inventory/Brands/`,
  inventoryChannelNames: `inventory/ChannelNames/`,
  busPlacement: `bus/placement/`,
  busPlacementDetail: args => `bus/placement/${args}/`,
  busRoutes: `bus/route/`,
  busRoutesDetail: args => `bus/route/${args}/`,
  busVehicles: `bus/vehicle/`,
  busCategories: `bus/category/`,
  busInterest: `bus/interest/`,
  busFile: `bus/file/`,
  busRouteCategory: args => `bus/route/${args}/category/`,
  notifySlack: `report/${v2}/notify_slack/`,
  busEmail: `report/${v2}/bus/`,
  executionAllOrder: `bus/order`,
  executionChangeStatus: args => `bus/order/status/${args}`,
  executionChangeStatusBulk: `bus/order/status/bulk`,
  executionNotifications: `bus/order/notifications`,
  busMeasurementCampaign: `/report/${v2}/bus-campaign/`,
  busMeasurementCampaignDetail: args => `/report/${v2}/bus-campaign/${args}`,
  busMeasurementCampaignReport: args => `/report/${v2}/bus-report/${args}`,
  busMeasurementCampaignReportByDate: args => `/report/${v2}/bus-report/${args}/by-date`,
  busMeasurementCampaignReportDetail: args => `/report/${v2}/bus-report-detail/${args}`,
  campaignContents: args =>`${v2}/campaign/${args}/content/`,
  contentApproval: args =>`${v2}/campaign/${args}/content_approval/`,
  sendEmailContent: args =>`${v2}/campaign/${args}/change_email/`,
  unassginedTicket: `pulse/${v2}/task/unassigned/`,
  teamPerformance: `${v2}/operation/performance/`,
  experienceBrandingDetail: args => `${v2}/experience-branding/${args}`,
  exBrandingDetailImage: args => `${v2}/experience-branding/${args}/images`,
  experienceBranding: `${v2}/experience-branding/`,
  experienceBrandingFilter: `${v2}/experience-branding/filter/`,
  airlinesDetail: args => `${v2}/airlines/${args}`,
  airlinesDetailImage: args => `${v2}/airlines/${args}/images`,
  airlines: `${v2}/airlines/listing/`,
  airlinesFilter: `${v2}/airlines/filter/`,
  taskManagerUnassignedTask: `${v2}/monitoring/ticket/unassigned`,
  taskManagerAssignedTask: `${v2}/monitoring/assignee/tickets`,
  taskManagerAssignTask: args => `${v2}/monitoring/ticket/${args}/assign/`,
  taskManagerUnassignTask: args => `${v2}/monitoring/ticket/${args}/unassign/`,
  taskManagerDeleteTicket: args => `${v2}/monitoring/ticket/${args}/delete/`,
  listReportedTicket: `${v2}/monitoring/assesment/`,
  detailReportedTicket: args => `${v2}/monitoring/assesment/${args}/`,
  approveReportedTicket: args => `${v2}/monitoring/assesment/${args}/approve/`,
  rejectReportedTicket: args => `${v2}/monitoring/assesment/${args}/reject/`,
  taskManagerCampaignList: `${v2}/monitoring/campaign/simple/`,
  taskManagerCampaignLocationList: args => `${v2}/monitoring/campaign/${args}/listings/`,
  taskManagerCreateTask: `${v2}/monitoring/ticket/create/`,
  taskManagerCampaignListPage: `${v2}/monitoring/campaign/`,
  landingPage: `${v2}/product/landing/`,
  citiesList: `${v2}/cities/`,
  taskManagerCampaignEdit: args => `${v2}/monitoring/campaign/${args}/`,
  getUser: `${v2}/user_email/`,
  monitoringCampaignDashboard: `${v2}/monitoring/dashboard/`,
  monitoringCampaignDashboardDetail: args => `${v2}/monitoring/dashboard/${args}/`,
  monitoringIssueList: args => `${v2}/monitoring/dashboard/${args}/issue/`,
  monitoringIssueImage: args => `${v2}/monitoring/dashboard/${args}/report/`,
  monitoringPopulateImageFilter: args => `${v2}/monitoring/dashboard/${args}/filter/`,
  searchResult: `${v2}/search/`,
  searchFilter: `${v2}/search/filter-menu`,
  spbuResult:  `${v2}/product/listing/`,
  measurementPertamina: args =>  `${v2}/measurement/dashboard/campaign/${args}/`,
  measurementPertaminaList: `${v2}/measurement/dashboard/campaign/`,
  measurementPertaminaChart: args =>  `${v2}/measurement/dashboard/campaign/${args}/chart/`,
  measurementPertaminaDemographic: args =>  `${v2}/measurement/dashboard/campaign/${args}/demographic/`,
  // busMonitoring: args => `${v2}/bus_monitoring/campaign/${args}/vehicles/detail/`,
  // busMonitoringPosition: args => `${v2}/bus_monitoring/campaign/${args}/vehicles/position/`,
  // busMonitoringStatus: args => `${v2}/bus_monitoring/campaign/${args}/vehicles/status/`,
  busMeasurement: args => `${v2}/bus_monitoring/campaign/${args}/measurement/`,
  logProofReport: args => `${v2}/data/campaign/${args}/log-proof-report/`,
  // busMeasurementSummary: args => `${v2}/bus_monitoring/campaign/${args}/measurement_summary/`,
  // busRouteSummary: args => `${v2}/bus_monitoring/campaign/${args}/route_summary/`,
  // busVehicleSummary: args => `${v2}/bus_monitoring/campaign/${args}/vehicle_summary/`,
  // busCoverageSummary: args => `${v2}/bus_monitoring/campaign/${args}/coverage_summary/`,
  logProofTransit: args => `${v2}/report/campaign/${args}/log-proof/transit/`,
  getDetailSPBU: args => `${v2}/product/${args}/`,
  spbuResult:  `${v2}/product/listing/`,
  dashboardStaticCampaign: `${v2}/monitoring/parent/`,
  dashboardStaticDetail: args => `${v2}/monitoring/campaign/${args}/parent`,
  dashboardStaticDigitalScreen: args => `${v2}/monitoring/parent/detail/${args}/idooh/`,
  dashboardStaticDSContent: args => `${v2}/monitoring/parent/detail/${args}/idooh/contents`,
  dashboardStaticExperienceBranding: args => `${v2}/monitoring/parent/detail/${args}/static/`,
  dashboardMonitoringDS: args => `${v2}/monitoring/parent/monitoring/${args}/idooh/`,
  dashboardMonitoringEB: args => `${v2}/monitoring/parent/monitoring/${args}/static/`,
  dashboardParentCampaign: args => `${v2}/monitoring/parent/detail/${args}/`,
  logProofDS: args => `${v2}/report/campaign/${args}/log-proof/digital_screen/`,
  dashboardMonitoringEB: args => `${v2}/monitoring/parent/monitoring/${args}/static/`,

  // share of voice map
  sovListLocation: `${v2}/sov/locations/`,
  sovBrandInLocation: `${v2}/sov/locations_and_brand/`,
  sovListCode: `${v2}/sov/list_code/`,
  sovFilter: `${v2}/sov/location_filter/`,
  sovHistory: `${v2}/sov/history_placement/`,
  sovUpdate: args => `${v2}/sov/placements/${args}/`,
  sovEditLocation: args => `${v2}/sov/sov_edit/${args}/`,
  sovListRoute: `${v2}/sov/routes/`,
  sovCreateBrands: `${v2}/sov/brands/`,
  sovImageUpload: args => `${v2}/sov/${args}/image/update/`,
  sovFilterCity: `${v2}/sov/locations_total_brand`,

  // utility page
  csvToKml: `${v2}/data/csv_to_kml/`,

  // dashboard campaign host revenue
  campaignHostRevenueReport: `${v2}/campaign-host-revenue/report/`,
  campaignHostRevenueBalance: `${v2}/campaign-host-revenue/final_balance/`,

  // List camopaign baru
  campaignList : `${v2}/campaigns/list/`,
  campaignHostBalance: `${v2}/campaigns/host-balance/`,
}


export default {
  apiV2
}
